<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in getRoute()"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";
import { findIndex } from "@/utils";
import { transactionSearch } from "@/api/firewall";
export default {
  components: { SidebarItem, Logo },
  watch: {
    $route(to, from) {
      this.search();
    }
  },
  computed: {
    ...mapGetters(["sidebar", "user_compliancework", "is_whitelabel"]),

    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  data() {
    return {
      routes: {},
      formSearch: {
        plusuid: "",
        membercode: "",
        startDate: "",
        endDate: "",
        bankholderId: "",
        status: "wait",
        onlyhitfirewall: true,
        paymentType: ""
      }
    };
  },
  methods: {
    search() {
      if (this.user_compliancework) {
        transactionSearch(this.formSearch).then(({ result, data }) => {
          if (result) {
            const routeIndex = findIndex(
              this.$router.options.routes,
              "/firewall",
              "path"
            );
            this.$router.options.routes[routeIndex].meta.badge = data.length;
            this.$router.options.routes[routeIndex].hidden = !this
              .user_compliancework;
          }
        });
      }

      if (this.is_whitelabel) {
        const routeIndex = findIndex(
          this.$router.options.routes,
          "/introducer",
          "path"
        );

        this.$router.options.routes[routeIndex].hidden = this.is_whitelabel;
      }
      this.routes = this.$router.options.routes;
      this.$forceUpdate();
    },
    getRoute() {
      return this.routes;
    }
  },
  created() {
    this.search();
  }
};
</script>
